import * as React from 'react';
import {Link} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {useEffect, useState} from 'react';
import RegistrationStepper from '../components/RegistrationStepper';
import {Button, Card, Col, Form, Row, CardGroup, InputGroup} from 'react-bootstrap';
import {listTags} from '../actions/tagActions';
import Loader from '../components/Loader';
import {createVideoPlayer} from '../actions/videoPlayerActions';
import Message from '../components/Message';
import {VIDEO_PLAYER_CREATE_RESET} from '../constants/videoPlayerConstants';
import {TAG_LIST_RESET} from '../constants/tagConstants';
import Select from "react-select";
import {listVideoCampaigns} from "../actions/videoCampaignActions";
import './PlayerScreen_autcomplete.css';
import {logout} from "../actions/userActions";
import ThreeColumnRow from "../components/ThreeColumnRow";
import CreatableSelect from "react-select/creatable";
import BusinessHoursTable from "../components/BusinessHoursTable";

const VideoPlayerRegisterScreen = ({history, language, t}) => {
    const MIN_STEP = 0;
    const MAX_STEP = 3;

    const dispatch = useDispatch();
    const userLogin = useSelector((state) => state.userLogin);
    const {userInfo} = userLogin;


    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [description, setDescription] = useState('');
    const [country, setCountry] = useState('');
    const [city, setCity] = useState('');
    const [address, setAddress] = useState('');
    const [zip, setZip] = useState('');

    const [generalHours, setGeneralHours] = useState({
        from: '06:00',
        to: '18:00',
        open: true,
    });
    const [businessHours, setBusinessHours] = useState([
        {
            from: '06:00',
            to: '18:00',
            open: true,
        },
        {
            from: '06:00',
            to: '18:00',
            open: true,
        },
        {
            from: '06:00',
            to: '18:00',
            open: true,
        },
        {
            from: '06:00',
            to: '18:00',
            open: true,
        },
        {
            from: '06:00',
            to: '18:00',
            open: true,
        },
        {
            from: '06:00',
            to: '18:00',
            open: true,
        },
        {
            from: '06:00',
            to: '18:00',
            open: true,
        },
    ]);

    const days = [
        t('monday'),
        t('tuesday'),
        t('wednesday'),
        t('thursday'),
        t('friday'),
        t('saturday'),
        t('sunday'),
    ];

    const [errors, setErrors] = useState({
        name: '',
        email: '',
        description: '',
        country: '',
        city: '',
        zip: '',
        address: '',
    });

    const tagList = useSelector((state) => state.tagList);
    const {
        loading: tagsLoading,
        error: tagsError,
        tags: userTags,
        success: userTagSuccess,
    } = tagList;
    const [tags, setTags] = useState([]);
    const [suggestions, setSuggestions] = useState([]);

    useEffect(() => {
        if (!userTagSuccess) {
            dispatch(listTags());
        } else {
            setSuggestions(() =>
                userTags.map((tgs) => {
                    tgs.label = tgs.name;
                    tgs.value = tgs._id;
                    return tgs;
                })
            );
        }
    }, [userTagSuccess, dispatch]);

    const videoCampaignsList = useSelector((state) => state.videoCampaignList);
    const {loading: videoCampaignsLoading, videoCampaignList, error: videoCampaignsError, success: videoCampaignListSuccess} = videoCampaignsList;
    const [videoCampaignOptions, setVideoCampaignOptions] = useState([]);
    const [selectedVideoCampaigns, setSelectedVideoCampaigns] = useState([]);

    useEffect(() => {
        if (!userInfo) {
            history.push('/login');
        }
    }, [userInfo, history]);

    useEffect(()=>{
        if(tagsError && tagsError.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[tagsError]);


    useEffect(()=>{
        if(!videoCampaignListSuccess){
            console.log('dispatching campaign list');
            dispatch(listVideoCampaigns());
        }
        if(videoCampaignList){
            //console.log(videoCampaignList);
            const moddedList = videoCampaignList.map(element => {
                element.label = element.name;
                element.value = element._id;
                return element;
            });
            //console.log(videoCampaignList);
            setVideoCampaignOptions(moddedList);
        }
    },[dispatch, videoCampaignList, videoCampaignListSuccess]);

    const onVideoCampaignsSelected = (videoCampaignsFromSelect) => {
        setSelectedVideoCampaigns(videoCampaignsFromSelect);
    }

    const videoPlayerCreate = useSelector((state) => state.videoPlayerCreate);
    const {
        loading: createLoading,
        videoPlayer: createdVideoPlayer,
        error: createError,
    } = videoPlayerCreate;

    useEffect(() => {
        if (createLoading) {
        }

        if (createdVideoPlayer) {
            console.log('video player created');
            console.log(createdVideoPlayer);
            history.push('/video_players');
            dispatch({type: VIDEO_PLAYER_CREATE_RESET});
            dispatch({type: TAG_LIST_RESET});
        }

        if (createError) {
        }
    }, [createLoading, createdVideoPlayer, createError, history, dispatch]);

    const [stepNumber, setStepNumber] = useState(0);

    const validate = () => {
        let result = true;
        const namePattern = new RegExp(/^.{3,}$/);
        const emailPattern = new RegExp(
            /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );
        const zipPattern = new RegExp(/^[0-9]{3,8}$/);
        const fields = {
            name,
            email,
            description,
            country,
            city,
            zip,
            address,
        };

        Object.keys(fields).forEach((key) => {
            if (fields[key].trim() === '') {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [key]: t('video_player_validation_error_missing_field'),
                }));
                result = false;
            } else {
                switch (key) {
                    case 'name':
                        if (!namePattern.test(fields[key])) {
                            setErrors((prevErrors) => ({
                                ...prevErrors,
                                [key]: t('video_player_validation_error_name_too_short'),
                            }));
                            result = false;
                        } else {
                            setErrors((prevErrors) => ({
                                ...prevErrors,
                                [key]: ``,
                            }));
                        }
                        break;
                    case 'email':
                        if (!emailPattern.test(fields[key])) {
                            setErrors((prevErrors) => ({
                                ...prevErrors,
                                [key]: t('video_player_validation_error_incorrect_email'),
                            }));
                            result = false;
                        } else {
                            setErrors((prevErrors) => ({
                                ...prevErrors,
                                [key]: ``,
                            }));
                        }
                        break;
                    case 'zip':
                        if (!zipPattern.test(fields[key])) {
                            setErrors((prevErrors) => ({
                                ...prevErrors,
                                [key]: t('video_player_validation_error_incorrect_zip'),
                            }));
                            result = false;
                        } else {
                            setErrors((prevErrors) => ({
                                ...prevErrors,
                                [key]: ``,
                            }));
                        }
                        break;
                    default:
                        if (fields[key].trim() !== '') {
                            setErrors((prevErrors) => ({
                                ...prevErrors,
                                [key]: ``,
                            }));
                        }
                }
            }
        });
        return result;
    };

    const nextStep = () => {
        const result = validate();
        if (!result) {
            return;
        }
        if (stepNumber < MAX_STEP) {
            setStepNumber(stepNumber + 1);
        }
    };

    const previousStep = () => {
        if (stepNumber > MIN_STEP) {
            setStepNumber(stepNumber - 1);
        }
    };

    const submitPlayerForm = (e) => {
        e.preventDefault();
        const properCampaigns = selectedVideoCampaigns.map(element => {
            let {label,value,...rest} = element;
            return rest;
        });

        const newVideoPlayer = {
            name: name,
            email: email,
            description: description,
            tags: tags,
            country: country,
            city: city,
            zip: zip,
            isActive: true,
            address: address,
            businessHours: businessHours,
            videoCampaigns: properCampaigns,
        };

        dispatch(createVideoPlayer(newVideoPlayer));
        dispatch({type: TAG_LIST_RESET});
    };

    const getStepComponent = (step) => {
        switch (step) {
            case 0:
                return (
                    <>
                        <Row>
                            <Col sm={12} md={6}>
                                <Form.Group controlId='name'>
                                    <Form.Label>{t('video_player_name')}</Form.Label>
                                    <Form.Control
                                        type='name'
                                        placeholder={t('video_player_name_description')}
                                        value={name}
                                        onChange={(e) =>
                                            setName(e.target.value)
                                        }
                                        required
                                        isInvalid={errors.name !== ''}
                                    />
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.name}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId='email'>
                                    <Form.Label>{t('video_player_email')}</Form.Label>
                                    <Form.Control
                                        type='email'
                                        placeholder={t('video_player_email_description')}
                                        value={email}
                                        onChange={(e) =>
                                            setEmail(e.target.value)
                                        }
                                        required
                                        isInvalid={errors.email !== ''}
                                    />
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.email}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId='description'>
                                    <Form.Label>
                                        {t('video_player_description')}
                                    </Form.Label>
                                    <Form.Control
                                        type='description'
                                        placeholder={t('video_player_description_description')}
                                        value={description}
                                        onChange={(e) =>
                                            setDescription(e.target.value)
                                        }
                                        required
                                        isInvalid={errors.description !== ''}
                                    />
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.description}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                {tagsLoading ? (
                                    <Loader/>
                                ) : (
                                    <Form.Group controlId='tags'>
                                        <Form.Label>{t('video_player_tags')}</Form.Label>
                                        <CreatableSelect
                                            isMulti
                                            isSearchable
                                            isClearable
                                            formatCreateLabel= {(inputValue) => `${t('create_tag')}: "${inputValue}"`}
                                            onChange={(newTag) => {
                                                const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                                if(temporaryTag !== null && temporaryTag !== undefined){
                                                    newTag = temporaryTag;
                                                }
                                                //console.log(newTag);
                                                setTags(newTag);
                                            }}
                                            onCreateOption={(newTag) => {
                                                const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                                if(temporaryTag !== null && temporaryTag !== undefined){
                                                    newTag = temporaryTag;
                                                }
                                                else {
                                                    newTag = {
                                                        id: undefined,
                                                        label: newTag,
                                                        value: newTag,
                                                        name: newTag
                                                    }
                                                }
                                                //console.log(newTag);
                                                setTags([...tags, newTag]);
                                            }}
                                            options={suggestions}
                                            value={tags}
                                            placeholder={t('video_player_tags_description')}
                                            className='react-select-container'
                                            classNamePrefix='react-select'
                                        />
                                        {/*<ReactTags
                                            allowNew={true}
                                            placeholderText={t('video_player_tags_description')}
                                            allowBackspace={false}
                                            onDelete={(idx) => {
                                                const newTags = tags.slice(0);
                                                newTags.splice(idx, 1);
                                                setTags(newTags);
                                            }}
                                            onAddition={(newTag) => {
                                                const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                                if(temporaryTag !== null && temporaryTag !== undefined){
                                                    newTag = temporaryTag;
                                                }
                                                //console.log(newTag);
                                                setTags([...tags, newTag]);
                                            }}
                                            suggestions={suggestions}
                                            tags={tags}
                                        />*/}
                                    </Form.Group>
                                )}
                            </Col>
                            <Col sm={12} md={6}>
                                <Form.Group controlId='country'>
                                    <Form.Label>{t('video_player_country')}</Form.Label>
                                    <Form.Control
                                        type='country'
                                        placeholder={t('video_player_country_description')}
                                        value={country}
                                        onChange={(e) =>
                                            setCountry(e.target.value)
                                        }
                                        required
                                        isInvalid={errors.country !== ''}
                                    />
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.country}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId='city'>
                                    <Form.Label>{t('video_player_city')}</Form.Label>
                                    <Form.Control
                                        type='city'
                                        placeholder={t('video_player_city_description')}
                                        value={city}
                                        onChange={(e) =>
                                            setCity(e.target.value)
                                        }
                                        required
                                        isInvalid={errors.city !== ''}
                                    />
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.city}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId='zip'>
                                    <Form.Label>{t('video_player_zip')}</Form.Label>
                                    <Form.Control
                                        type='zip'
                                        placeholder={t('video_player_zip_description')}
                                        value={zip}
                                        onChange={(e) => setZip(e.target.value)}
                                        required
                                        isInvalid={errors.zip !== ''}
                                    />
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.zip}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId='address'>
                                    <Form.Label>{t('video_player_address')}</Form.Label>
                                    <Form.Control
                                        type='address'
                                        placeholder={t('video_player_address_description')}
                                        value={address}
                                        onChange={(e) =>
                                            setAddress(e.target.value)
                                        }
                                        required
                                        isInvalid={errors.address !== ''}
                                    />
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.address}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    </>
                );
            case 1:
                return (
                    <div>
                        <BusinessHoursTable
                            days={days}
                            businessHours={businessHours}
                            generalHours={generalHours}
                            setBusinessHours={setBusinessHours}
                            setGeneralHours={setGeneralHours}
                            language={language}
                            t={t}
                        />
                    </div>
                );
            case 2:
                return <div className='mt-2'>
                    <Select isMulti options={videoCampaignOptions} onChange={onVideoCampaignsSelected} defaultValue={selectedVideoCampaigns} placeholder={t('video_player_select_video_campaigns')}/>
                </div>;
            default:
                return (
                    <>
                        <CardGroup className='h4'>
                            <Card bg='light'>
                                <ul className='list-group'>
                                    <li className='list-group-item list-group-item-primary font-weight-bold'>
                                        {t('video_player_registration_data')}:
                                    </li>
                                    <li className='list-group-item'>
                                        <span className='font-weight-bold'>
                                            {t('video_player_name')}:{' '}
                                        </span>
                                        {name}
                                    </li>
                                    <li className='list-group-item'>
                                        <span className='font-weight-bold'>
                                            {t('video_player_email')}:{' '}
                                        </span>
                                        {email}
                                    </li>
                                    <li className='list-group-item'>
                                        <span className='font-weight-bold'>
                                            {t('video_player_zip')}:{' '}
                                        </span>
                                        {zip}
                                    </li>
                                    <li className='list-group-item'>
                                        <span className='font-weight-bold'>
                                            {t('video_player_country')}:{' '}
                                        </span>
                                        {country}
                                    </li>
                                    <li className='list-group-item'>
                                        <span className='font-weight-bold'>
                                            {t('video_player_city')}:{' '}
                                        </span>
                                        {city}
                                    </li>
                                    <li className='list-group-item'>
                                        <span className='font-weight-bold'>
                                            {t('video_player_address')}:{' '}
                                        </span>
                                        {address}
                                    </li>
                                    <li className='list-group-item'>
                                        <span className='font-weight-bold'>
                                            {t('video_player_description')}:{' '}
                                        </span>
                                        {description}
                                    </li>
                                    <li className='list-group-item'>
                                        <span className='font-weight-bold'>
                                            {t('video_player_tags')}:{' '}
                                        </span>
                                        {tags.map((tag) => {
                                            return (
                                                <div key={tag._id}>
                                                    {tag.name}
                                                </div>
                                            );
                                        })}
                                    </li>
                                </ul>
                            </Card>
                            <Card>
                                <ul className='list-group'>
                                    <li className='list-group-item list-group-item-primary font-weight-bold'>
                                        {t('player_open_times')}
                                    </li>
                                    {days.map((day, index) => {
                                        return (
                                            <li
                                                className='list-group-item'
                                                key={index}
                                            >
                                                {day} :{' '}
                                                {businessHours[index].open
                                                    ? `${businessHours[index].from} - 
                              ${businessHours[index].to}`
                                                    : 'Zárva'}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </Card>
                            <Card>
                                <ul className='list-group'>
                                    <li className='list-group-item list-group-item-primary font-weight-bold'>
                                        {t('video_player_video_campaigns')}
                                    </li>
                                    {selectedVideoCampaigns.map(idk => (
                                        <li className='list-group-item'>
                                            {idk.name}
                                        </li>
                                    ))}
                                </ul>
                            </Card>
                        </CardGroup>
                        {createLoading ? <Loader/> : null}
                        {createError ? (
                            <Message variant='danger'>{createError}</Message>
                        ) : null}
                    </>
                );
        }
    };

    return (
        <>
            <ThreeColumnRow firstColumn={<Link to='/video_players' className='btn btn-info m-0 p-2'>
                {t('button_back')}
            </Link>} secondColumn={t('video_player_new_player')} thirdColumn={null}/>

            <RegistrationStepper
                steps={[
                    t('video_player_registration_data'),
                    t('player_open_times'),
                    t('video_player_video_campaigns'),
                    t('video_player_summary'),
                ]}
                activeStep={stepNumber}
            >
                <Form onSubmit={submitPlayerForm} autoComplete='off'>
                    <div style={{minHeight: '60vh'}}>
                        {getStepComponent(stepNumber)}
                    </div>
                    <div className='d-flex justify-content-center'>
                        <div className='d-flex justify-content-center'>
                            {stepNumber !== MIN_STEP ? (
                                <Button className='m-3' onClick={previousStep}>
                                    {t('button_previous')}
                                </Button>
                            ) : (
                                <Button
                                    className='m-3 invisible'
                                    onClick={previousStep}
                                >
                                    {t('button_previous')}
                                </Button>
                            )}
                            {stepNumber < MAX_STEP ? (
                                <Button className='m-3' onClick={nextStep}>
                                    {t('button_next')}
                                </Button>
                            ) : (
                                <Button
                                    className='m-3 invisible'
                                    onClick={nextStep}
                                >
                                    {t('button_next')}
                                </Button>
                            )}
                        </div>
                        {stepNumber === MAX_STEP ? (
                            <Button
                                variant='success'
                                className='m-3'
                                type='submit'
                            >
                                {t('button_finish')}
                            </Button>
                        ) : null}
                    </div>
                </Form>
            </RegistrationStepper>
        </>
    );
};
export default VideoPlayerRegisterScreen;
